// @ts-nocheck
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { useIsAuthenticated } from "@store/Framework/Store/Context/ContextHooks";
import CardComponent from "@store/Library/Widgets/Card/Card";
import { focusOutlineStyles } from "@store/Themes/common/mixins/common";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import React, { useMemo } from "react";
import { css } from "styled-components";

export interface BunzlAutoCompleteProductWrapperStyles {
    cardStyles: InjectableCss;
}
interface BunzlAutoCompleteProductWrapperProps {
    children: React.ReactNode;
    extendedStyles?: BunzlAutoCompleteProductWrapperStyles;
    variant: "outlined" | "elevated";
    isFocused?: boolean;
}

const BunzlAutoCompleteProductWrapper: React.FC<BunzlAutoCompleteProductWrapperProps> = ({
    children,
    extendedStyles,
    variant,
    isFocused,
}) => {
    const iAuthenticated = useIsAuthenticated();
    const bunzlAutoCompleteProductstyles: BunzlAutoCompleteProductWrapperStyles = useMemo(
        () => ({
            cardStyles: {
                css: css`
                    height: 100%;
                    width: 100%;
                    justify-content: ${iAuthenticated ? "space-between" : "flex-start"};
                `,
            },
        }),
        [iAuthenticated],
    );
    const styles = useMergeProps(bunzlAutoCompleteProductstyles, extendedStyles);
    const cardStyles = isFocused
        ? {
              ...styles.cardStyles,
              css: css`
                  ${styles.cardStyles.css}
                  ${focusOutlineStyles()}
              `,
          }
        : styles.cardStyles;
    return (
        <CardComponent size="xsmall" extendedStyles={cardStyles} variant={variant}>
            {children}
        </CardComponent>
    );
};

export default BunzlAutoCompleteProductWrapper;
